import { Avatar as NBAvatar, usePropsResolution } from 'native-base';
import React, { memo, forwardRef } from 'react';
import { UserOutlined } from '../Icon';
import type { IAvatarProps } from './Avatar.types';

const Avatar = ({ children, ...props }: IAvatarProps, ref: any) => {
  const { _icon } = usePropsResolution('Avatar', props);

  return (
    <NBAvatar {...props} ref={ref}>
      {children ? children : <UserOutlined {..._icon} />}
    </NBAvatar>
  );
};

export default memo(forwardRef(Avatar));
